import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="px-4 md:px-6 py-12 md:py-14">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-movie-2-line text-lg text-white"></i>
                </div>
                <span className="text-xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                  7777影院
                </span>
              </div>
              <p className="text-foreground-500 text-sm leading-relaxed mb-4">
                {siteInfo.description}
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200 hover:bg-background-300 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-foreground-600"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200 hover:bg-background-300 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-foreground-600"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200 hover:bg-background-300 transition-colors cursor-pointer" aria-label="QQ">
                  <i className="ri-qq-line text-foreground-600"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-foreground-950 font-semibold text-sm mb-4">
                <a href="/category/all" className="hover:text-primary-500 transition-colors cursor-pointer">热门分类</a>
              </h4>
              <div className="flex flex-col gap-2">
                {categories.slice(1, 7).map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="text-foreground-500 text-sm hover:text-primary-500 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-foreground-950 font-semibold text-sm mb-4">
                <a href="/category/all" className="hover:text-primary-500 transition-colors cursor-pointer">更多分类</a>
              </h4>
              <div className="flex flex-col gap-2">
                {categories.slice(7).map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="text-foreground-500 text-sm hover:text-primary-500 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-foreground-950 font-semibold text-sm mb-4">
                <a href="/about" className="hover:text-primary-500 transition-colors cursor-pointer">关于我们</a>
              </h4>
              <div className="flex flex-col gap-2">
                <Link to="/about" className="text-foreground-500 text-sm hover:text-primary-500 transition-colors cursor-pointer">
                  品牌介绍
                </Link>
                <Link to="/about" className="text-foreground-500 text-sm hover:text-primary-500 transition-colors cursor-pointer">
                  联系我们
                </Link>
                <Link to="/about" className="text-foreground-500 text-sm hover:text-primary-500 transition-colors cursor-pointer">
                  用户口碑
                </Link>
                <Link to="/about" className="text-foreground-500 text-sm hover:text-primary-500 transition-colors cursor-pointer">
                  隐私政策
                </Link>
              </div>
              <p className="text-foreground-400 text-xs mt-4">
                联系邮箱：{siteInfo.email}
              </p>
              <p className="text-foreground-400 text-xs">
                客服电话：{siteInfo.phone}
              </p>
            </div>
          </div>

          <div className="border-t border-background-200/60 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-400 text-xs text-center sm:text-left">
              &copy; 2018-2026 7777影院 77777777影院 版权所有 | 本站所有资源均来自互联网，仅供学习交流使用
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-400">
              <a href="/about" className="hover:text-foreground-600 transition-colors cursor-pointer">关于我们</a>
              <a href="/about" className="hover:text-foreground-600 transition-colors cursor-pointer">免责声明</a>
              <a href="/about" className="hover:text-foreground-600 transition-colors cursor-pointer">联系我们</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}